const Description = () => {
  return (
    <div className=" mt-8 px-3">
      <p className=" font-extrabold text-gray-6">تعیین قیمت:</p>
      <p className=" text-gray-6">
        خریداران نمی توانند قیمتی کمتر از قیمت پایه پیشنهاد دهند.
      </p>
    </div>
  );
};

export default Description;
